import React, { useState } from "react";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

import InquiryFormModal from "../common_components/InquiryFormModal/InquiryFormModal";
import "./Footer.css";

const Footer = () => {
  const [modalshow, setmodalshow] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleHomeClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      navigate("/");
    }
  };

  const programs = [
    "MBA",
    // "MBA(VX)",
    // "MCA",
    "BBA",
    // "BCA",
    // "B.Com",
    // "B.A",
    // "CPDM",
    // "CPHAHM",
  ];

  return (
    <>
      <section className="footer-section">
        <Container>
          <p class="footer_desc_text_holder">
            "<b>Disclaimer:</b> As an Affiliate Enquiry Partner(AEP) of
            Universities, we display and showcase program information of
            Universities. Counseling, Admission, Program delivery, and
            examination are solely managed by Universities, and as an AEP, we
            have no role to play in it"
          </p>
          <div className="row justify-content-center">
            <div className="col-md-12 col-12">
              <div className="row gy-4">
                {/* Logo */}
                <div className="col-lg-3 col-md-6">
                  <img
                    className="footerlogo"
                    src="/assets/images/logo_swiper/atlas-logo.png"
                    alt="Logo"
                  />

                  <p className="footer_address mt-4">
                    2nd Floor, Office No.3, Opp. High Class Society, Pashan
                    Road, Bavdhan, Pune - 411021
                  </p>
                </div>

                {/* Programmes */}
                <div className="col-lg-2 col-md-6">
                  <h4 className="footer_heading">Programmes</h4>

                  {programs.map((item) => (
                    <p
                      key={item}
                      className="footer_link"
                      onClick={() => setmodalshow(true)}
                    >
                      {item}
                    </p>
                  ))}
                </div>

                {/* Policies */}
                {/* <div className="col-lg-2 col-md-6">
                  <h4 className="footer_heading">Policies</h4>

                  <p className="footer_link" onClick={() => setmodalshow(true)}>
                    Admission Policy
                  </p>
                  <p className="footer_link" onClick={() => setmodalshow(true)}>
                    Terms & Conditions
                  </p>
                </div> */}

                {/* About */}
                {/* <div className="col-lg-2 col-md-6">
                  <h4 className="footer_heading">Disclaimer</h4>

                  <p className="disclaimer">
                    As an Affiliate Enquiry Partner (AEP) of Universities, we
                    display and showcase program information of Universities.
                    Counseling, Admission, Program delivery, and examination are
                    solely managed by Universities, and as an AEP, we have no
                    role to play in it.
                  </p>
                </div> */}

                {/* Contact */}
                {/* <div className="col-lg-3 col-md-6">
                  <h4 className="footer_heading">Contact Us</h4>

                  <p className="footer_contact">
                    <strong>Address:</strong>
                    <br />
                    2nd Floor, Office No.3,
                    <br />
                    Opp. High Class Society,
                    <br />
                    Pashan Road, Bavdhan,
                    <br />
                    Pune - 411021
                  </p>

                  <p className="footer_contact">
                    <strong>Email:</strong>
                    <br />
                    info@profcyma.com
                  </p>

                  <p className="footer_contact">
                    <strong>Phone:</strong>
                    <br />
                    +91 9607755557
                  </p>
                </div> */}
              </div>
            </div>
          </div>

          <div className="border"></div>

          {/* Bottom */}
          <div className="copyrights-div text-center">
            <p className="title">
              Copyright 2026 of Atlas SkillTech University CDOE AEP Profcyma
              | | All Rights Reserved Privacy Policy
            </p>
          </div>
        </Container>
      </section>

      <InquiryFormModal
        show={modalshow}
        onHide={() => setmodalshow(false)}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </>
  );
};

export default Footer;
